import { useLocation } from 'react-router';
import * as yup from 'yup';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import Model from '../models/model'
import connectionService from '../services/Connection';
import QuickSearchFrom from '../views/forms/QuickSearchForm';
import { dataStore } from '../Store';
import strings from '../Globalization';

export const loadScope = field => async (...args) => {
	const {
		ManufacturerName,
		ScopeType,
	} = args[0]
	const { formik } = args[1];
	if (field === 'ScopeType') {
		formik.setFieldValue('ScopeType', undefined)
		formik.setFieldValue('ScopeModel', undefined)
	}
	const isManufacturer = args[0].hasOwnProperty("ManufacturerName");
	const isScopeType = args[0].hasOwnProperty("ScopeType");
	let where = { "IsDeleted": false };
	if (isManufacturer && !isScopeType && !ManufacturerName && !ScopeType) {
		//Initial level Excute 
		return fetchOperation('ScopeType', where)
	}
	if (isManufacturer && isScopeType && !ManufacturerName && !ScopeType) {
		//Initial level Excute
		return fetchOperation('ScopeModel', where)
	}
	if (!!ManufacturerName && !isScopeType) {
		//When ManufacturerName key has a value then its excute 
		where = { ...where, 'ManufacturerName': ManufacturerName }
		return await fetchOperation('ScopeType', where);
	}
	if (isScopeType && !!ManufacturerName && !ScopeType) {
		//When ManufacturerName is selected and scopetype has empty value  then its excute
		where = { ...where, 'ManufacturerName': ManufacturerName }
		return await fetchOperation('ScopeModel', where);
	}
	if (!!ManufacturerName && !!ScopeType) {
		// When the manufacturer and scopetype is selected  populating scopemodel
		where = { 'ManufacturerName': ManufacturerName, 'ScopeType': ScopeType };
		return await fetchOperation('ScopeModel', where);
	}
	if (!ManufacturerName && !!ScopeType) {
		// when scopetype is selected populate the scopemodel
		where = { 'ScopeType': ScopeType };
		return await fetchOperation('ScopeModel', where);
	}
}
const fetchOperation = async (comboType, where) => {
	const formData = new FormData();
	formData.append('comboType', comboType);
	formData.append('where', JSON.stringify(where))
	const { options, count } = await fetch(connectionService.Combo, {
		method: 'POST',
		body: formData
	}).then((res) => res.json()).then((json) => {
		const { records } = json;
		let options = records?.map((record) => ({
			id: record.LookupId,
			label: record.DisplayValue
		}));
		if (!Array.isArray(options)) {
			options = [];
		}
		return { options: options || [], count: options?.length };
	});
	return { options, count };

}
const NonMedivatorButton = () => {
	const location = useLocation()
	const { auth = {} } = dataStore?.getState() || {};
	const { roles = [] } = auth;
	const returnTo = encodeURIComponent(location.pathname);
	const scopeParam = location.pathname.toLowerCase() === '/endosetup' ? '&ItemType=Scope' : ''
	return (
		!roles?.includes('Operator') &&
		<Button component={Link} to={`/nonmedivator?id=new${scopeParam}&returnTo=${returnTo}`} variant="contained" size="small">{strings.cabinets}</Button>
	);
}
const model = new Model({
	name: 'HuluScope',
	idProperty: '_id',
	allowImport: false,
	disableDelete: true,
	disableAdd: true,
	disableExport: true,
	disableFiltering: true,
	defaultSort: 'ManufacturerName ASC',
	title: 'QuickSearchScope',
	pageSize: 15,
	readOnly: false,
	customeFormTitle: 'Add',
	showGridRefreshBtn: true,
	gridToolbarCustomActions: [
		{
			Component: NonMedivatorButton
		}
	],
	customizeSaveData: (toSave, { values }) => {	
		const returnTo ={ ...toSave, ...values };
		returnTo.RemoveScopes = JSON.stringify(returnTo?.RemoveScopes || []);
		returnTo.ScopeDetails = JSON.stringify(returnTo?.ScopeDetails || []);
		returnTo.EquipmentModel=JSON.stringify(returnTo?.EquipmentModel|| [])
		return returnTo;
	},
	FormExtension: ({ formik, activeRecord }) => {
		//Child grid
		return (
			<QuickSearchFrom activeRecord={activeRecord} formik={formik} />
		)
	},
	formGroups: [{
		fields: ["ManufacturerName", "ScopeType", "ScopeModel", "EquipmentModel"]
	}],
	columns: [
		{ header: 'Manufacturer', field: 'ManufacturerName', width: 120, isNotformfield: true, headerFilter: true, lookup: 'ManufacturerName', eager: true, headerFilterProps: { label: 'Manufacturer', multiple: false }, standaloneHeaderFilter: true, readOnly: true },
		{ header: 'Manufacturer', field: 'ManufacturerName', width: 120, readOnly: true },
		{ header: 'scopeType', field: 'ScopeType', width: 200, isNotformfield: true, headerFilter: true, lookup: loadScope('ScopeType'), dependsOn: ['ManufacturerName'], type: 'string', headerFilterProps: { label: 'scopeType', multiple: false }, standaloneHeaderFilter: true, readOnly: true },
		{ header: 'scopeType', field: 'ScopeType', width: 200, readOnly: true },
		{ header: 'ScopeModel', field: 'ScopeModel', width: 120, headerFilter: true, lookup: loadScope('ScopeModel'), dependsOn: ['ManufacturerName', 'ScopeType'], type: 'string', headerFilterProps: { label: 'ScopeModel', multiple: false }, standaloneHeaderFilter: true, readOnly: true },
		{ header: 'ScopeModel', field: 'ScopeModel', width: 120, isNotformfield: true, readOnly: true },
		{
			field: 'ScopeDetails', width: 100, hidden: true, type: 'object',
			validate: yup.array().of(
				yup.object().shape({
					ScopeName: yup.string(),
					SerialNumber: yup.string().max(100, 'SerialNumberValidation'),
				})
			).test({
				name: 'DuplicateSerialNumber',
				test: function (values) {
					const uniqueCodes = new Set();
					for (let i = 0, len = values?.length; i < len; i++) {
						if (uniqueCodes.has(values[i].SerialNumber || values[i].SerialNumber === undefined)) {
							return false;
						}
						uniqueCodes.add(values[i].SerialNumber);
					}
					return true;
				}, message: 'DuplicateSerialNumber',
			}).test({
				name: 'SerialNumberisRequired',
				test: function (values) {
					const serialNumbers = values?.filter(item => item?.SerialNumber === '' || item?.SerialNumber === undefined);
					return serialNumbers?.length === 0;
				}, message: 'SerialNumberisRequired'
			})
			,
			excludeOnGrid: true
		},
		{ header: 'Image', field: 'Image', type: 'action', width: 120, isNotformfield: true },
		{ header: 'Select', field: 'Select', type: 'action', width: 120, isNotformfield: true },
		{ header: 'EquipmentModel', field: 'EquipmentModel', width: 120, lookup: 'Model', multiple: true, readOnly: true, excludeOnGrid: true },	

	]
});

export const QuickSerachModel = model;
export default model.createFormBase();